
























import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { debounce, dom } from 'quasar'
import ViewStart from 'components/presenter/item/topic/viewer/Start.vue'
import ViewSlide from 'components/presenter/item/topic/viewer/Slide.vue'
import ViewImage from 'components/presenter/item/topic/viewer/Image.vue'
import ViewMovie from 'components/presenter/item/topic/viewer/Movie.vue'
import ViewChoice from 'components/presenter/item/topic/viewer/Choice.vue'
import ViewYesNo from 'components/presenter/item/topic/viewer/YesNo.vue'
import ViewOrder from 'components/presenter/item/topic/viewer/Order.vue'
import ViewNumber from 'components/presenter/item/topic/viewer/Number.vue'
import ViewGaps from 'components/presenter/item/topic/viewer/Gaps.vue'
import ViewEssay from 'components/presenter/item/topic/viewer/Essay.vue'
import ViewVote from 'components/presenter/item/topic/viewer/Vote.vue'
import ViewRate from 'components/presenter/item/topic/viewer/Rate.vue'
import ViewOpen from 'components/presenter/item/topic/viewer/Open.vue'
import ViewParams from 'components/presenter/item/topic/viewer/Params.vue'
import { SlideParamsValuesSet, QuizSlideResult } from 'src/assets/AttendeeItemData'

@Component({
  components: {
    ViewStart,
    ViewSlide,
    ViewImage,
    ViewMovie,
    ViewChoice,
    ViewYesNo,
    ViewOrder,
    ViewNumber,
    ViewGaps,
    ViewEssay,
    ViewVote,
    ViewRate,
    ViewOpen,
    ViewParams
  }
})
export default class AttendeeResponseViewer extends Vue {
  visible = false

  @Prop({ default: 700 })
  readonly virtualDelay!: number

  @Prop()
  readonly slide!: Json

  @Prop({ default: false })
  readonly keynote!: boolean

  @Prop()
  readonly seed!: string | undefined

  @Prop({ type: Object, default: () => { return {} } })
  readonly params!: SlideParamsValuesSet

  @Prop()
  readonly result!: QuizSlideResult | undefined

  @Prop()
  readonly stats!: Json | undefined

  @Prop({ default: false })
  readonly readonly!: boolean

  @Prop()
  readonly value!: { [key: string]: boolean | string } | number[] | number | string[] | undefined

  @Prop({ default: () => { return {} } })
  readonly meta!: Json

  @Prop({ default: false })
  readonly feedbackButtonShow!: boolean

  @Prop({ default: false })
  readonly feedbackButtonShowAlways!: boolean

  @Prop({ default: false })
  readonly feedbackButtonOn!: boolean

  created () {
    if (this.virtualDelay) {
      this.onIntersection = debounce(this.onIntersection, this.virtualDelay)
    }
  }

  onIntersection (e: IntersectionObserverEntry) {
    this.visible = this.visible || e.isIntersecting
  }
}
